export default {
  CONFIGURADOR: 'Configurador',
  RESPONSABLE_DE_TRABAJOS: 'Responsable de trabajos',
  OPERARIO: 'Operario',
  REVISOR_DE_INTERVENCIONES: 'Revisor de intervenciones',
  SOLO_CONSULTA: 'Solo consulta'
}
